exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ntable[data-v-d0334a06],th[data-v-d0334a06],td[data-v-d0334a06] {\n\tbackground-color: #ffffff;\n\tborder-collapse: collapse;\n\tborder: 0px solid black;\n\tempty-cells: show;\n}\ntd[data-v-d0334a06]{\n\tposition:relative;\n}\n.colname[data-v-d0334a06]{\n\tposition:relative;\n\tpadding:0px;\n\tmargin:0px;\n\tfont-size:10px;\n\tfont-weight:bold;\n}\n.coldata[data-v-d0334a06]{\n\tposition:relative;\n\tpadding:0px;\n\tmargin:0px;\n\tfont-size:20px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d0334a06","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/layouts/layout_3.vue
// module id = 745
// module chunks = 0